export const AddFileIcon = () => (
  <svg
    viewBox="0 0 161 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="h-[38px] w-[99px] md:h-[73px] md:w-[161px]"
  >
    <path
      d="M59.9072 7.89967L56.628 8.78261C48.4006 11.0008 46.005 15.1828 48.2226 23.3903L50.4401 31.5979C52.3427 38.6867 55.7252 41.4658 61.8801 40.6645C62.867 40.5521 63.9297 40.3381 65.0683 40.0224L68.3667 39.119C76.5538 36.8823 78.9698 32.7195 76.7522 24.512L74.534 16.2846C74.0816 14.6156 73.5574 13.1671 72.9231 11.9797C70.4466 7.26808 66.4649 6.11401 59.9072 7.89967Z"
      fill="url(#paint0_linear_611_2970)"
    />
    <path
      d="M59.9072 7.89967L56.628 8.78261C48.4006 11.0008 46.005 15.1828 48.2226 23.3903L50.4401 31.5979C52.3427 38.6867 55.7252 41.4658 61.8801 40.6645C62.867 40.5521 63.9297 40.3381 65.0683 40.0224L68.3667 39.119C76.5538 36.8823 78.9698 32.7195 76.7522 24.512L74.534 16.2846C74.0816 14.6156 73.5574 13.1671 72.9231 11.9797C70.4466 7.26808 66.4649 6.11401 59.9072 7.89967Z"
      fill="black"
      fillOpacity={0.1}
    />
    <path
      d="M105.064 7.89967L108.343 8.78261C116.57 11.0008 118.966 15.1828 116.748 23.3903L114.531 31.5979C112.628 38.6867 109.246 41.4658 103.091 40.6645C102.104 40.5521 101.041 40.3381 99.9024 40.0224L96.604 39.119C88.4169 36.8823 86.0009 32.7195 88.2185 24.512L90.4367 16.2846C90.8891 14.6156 91.4133 13.1671 92.0476 11.9797C94.5241 7.26808 98.5058 6.11401 105.064 7.89967Z"
      fill="url(#paint1_linear_611_2970)"
    />
    <path
      d="M105.064 7.89967L108.343 8.78261C116.57 11.0008 118.966 15.1828 116.748 23.3903L114.531 31.5979C112.628 38.6867 109.246 41.4658 103.091 40.6645C102.104 40.5521 101.041 40.3381 99.9024 40.0224L96.604 39.119C88.4169 36.8823 86.0009 32.7195 88.2185 24.512L90.4367 16.2846C90.8891 14.6156 91.4133 13.1671 92.0476 11.9797C94.5241 7.26808 98.5058 6.11401 105.064 7.89967Z"
      fill="black"
      fillOpacity={0.1}
    />
    <path
      d="M140.064 21.8997L143.343 22.7826C151.57 25.0008 153.966 29.1828 151.748 37.3903L149.531 45.5979C147.628 52.6867 144.246 55.4658 138.091 54.6645C137.104 54.5521 136.041 54.3381 134.902 54.0224L131.604 53.119C123.417 50.8823 121.001 46.7195 123.218 38.512L125.437 30.2846C125.889 28.6156 126.413 27.1671 127.048 25.9797C129.524 21.2681 133.506 20.114 140.064 21.8997Z"
      fill="url(#paint2_linear_611_2970)"
    />
    <path
      d="M140.064 21.8997L143.343 22.7826C151.57 25.0008 153.966 29.1828 151.748 37.3903L149.531 45.5979C147.628 52.6867 144.246 55.4658 138.091 54.6645C137.104 54.5521 136.041 54.3381 134.902 54.0224L131.604 53.119C123.417 50.8823 121.001 46.7195 123.218 38.512L125.437 30.2846C125.889 28.6156 126.413 27.1671 127.048 25.9797C129.524 21.2681 133.506 20.114 140.064 21.8997Z"
      fill="black"
      fillOpacity={0.1}
    />
    <path
      d="M20.9072 14.8997L17.628 15.7826C9.4006 18.0008 7.00501 22.1828 9.22258 30.3903L11.4401 38.5979C13.3427 45.6867 16.7252 48.4658 22.8801 47.6645C23.867 47.5521 24.9297 47.3381 26.0683 47.0224L29.3667 46.119C37.5538 43.8823 39.9698 39.7195 37.7522 31.512L35.534 23.2846C35.0816 21.6156 34.5574 20.1671 33.9231 18.9797C31.4466 14.2681 27.4649 13.114 20.9072 14.8997Z"
      fill="url(#paint3_linear_611_2970)"
    />
    <path
      d="M20.9072 14.8997L17.628 15.7826C9.4006 18.0008 7.00501 22.1828 9.22258 30.3903L11.4401 38.5979C13.3427 45.6867 16.7252 48.4658 22.8801 47.6645C23.867 47.5521 24.9297 47.3381 26.0683 47.0224L29.3667 46.119C37.5538 43.8823 39.9698 39.7195 37.7522 31.512L35.534 23.2846C35.0816 21.6156 34.5574 20.1671 33.9231 18.9797C31.4466 14.2681 27.4649 13.114 20.9072 14.8997Z"
      fill="black"
      fillOpacity={0.1}
    />
    <rect
      x={69.2256}
      y={48.6187}
      width={23.756}
      height={23.756}
      rx={5.95045}
      fill="url(#paint4_linear_611_2970)"
    />
    <rect
      x={69.2256}
      y={48.6187}
      width={23.756}
      height={23.756}
      rx={5.95045}
      fill="black"
      fillOpacity={0.1}
    />
    <path d="M80.168 54.5688H82.0398V66.4239H80.168V54.5688Z" fill="white" />
    <path d="M75.1763 59.5605H87.0313V61.4324H75.1763V59.5605Z" fill="white" />
    <defs>
      <linearGradient
        id="paint0_linear_611_2970"
        x1={58.1162}
        y1={4.76831}
        x2={56.5087}
        y2={50.5385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_611_2970"
        x1={106.855}
        y1={4.76831}
        x2={108.462}
        y2={50.5385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_611_2970"
        x1={141.855}
        y1={18.7683}
        x2={143.462}
        y2={64.5385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_611_2970"
        x1={19.1162}
        y1={11.7683}
        x2={17.5087}
        y2={57.5385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_611_2970"
        x1={74.1064}
        y1={48.6187}
        x2={95.7961}
        y2={72.9187}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#026051" />
        <stop offset={1} stopColor="#3B5F59" stopOpacity={0} />
        <stop offset={1} stopColor="#47A092" />
      </linearGradient>
    </defs>
  </svg>
);
